<template>
  <div class="card">
    <DataTable
        :value="sourceProducts"
        dataKey="product_id"
        :paginator="true"
        :rows="10"
        :totalRecords="sourceProducts.length"
        :lazy="false"
    >
      <!-- Dynamic columns -->
      <Column
          v-for="col in columns"
          :key="col.field"
          :field="col.field"
          :header="col.header"
          :headerStyle="{ width: col.width }"
      >
        <!-- Custom Content for Action Column -->
        <template v-if="col.custom" #body="slotProps">
          <AppButton color="blue" label=""
                     :icon="true"
                     class="mr-1"
                     @click="emitProduct(slotProps.data)">
            <template v-slot:icon>
              <Icon iconType="copy-plus"/>
            </template>
          </AppButton>
        </template>
      </Column>
    </DataTable>
  </div>
</template>


<script>

import AppButton from "@/components/Button.vue";
import Icon from "@/components/Icon.vue";
import notificationMixin from "@/mixins/notificationMixin";
import { resolveListPrice, resolveProductUnitPrice } from "@/views/HR/Sales/salesPriceLookup";

export default {
  components: {
    AppButton,
    Icon
  },
  mixins: [notificationMixin],
  props: {
    searchTerm: String,
    // Internal sheets always price parts at List Price; external sheets use
    // the job customer's assigned band, falling back to List Price.
    jobType: {
      type: String,
      default: 'external',
    },
    customerPriceBand: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      rawProducts: [],
      sourceProducts: [],
      columns: [
        {field: 'product_code', header: 'Code', width: '15%'},
        {field: 'name', header: 'Name', width: '70%'},
        {field: 'cost_price', header: 'Price', width: '10%'},
        {header: 'Action', width: '5%', custom: true}
      ],
    };
  },

  watch: {
    searchTerm(newValue) {
      this.loadProducts(newValue);
    },
    // Reprice already-listed products when the customer band arrives after the
    // search results, or when the sheet switches between internal and external.
    jobType() {
      this.projectPrices();
    },
    customerPriceBand() {
      this.projectPrices();
    }
  },
  methods: {
    async loadProducts(searchTerm = '') {
      try {
        const products = await this.ProductService.getProductsByV2(searchTerm);
        this.rawProducts = products || [];
        this.projectPrices();
      } catch (error) {
        this.notifyError("Error loading products");
        console.error(error);
      }
    },
    projectPrices() {
      this.sourceProducts = this.rawProducts.map(p => Object.assign({}, p, {
        cost_price: this.jobType === 'internal'
            ? resolveListPrice(p)
            : resolveProductUnitPrice(p, this.customerPriceBand),
      }));
    },
    emitProduct(product) {
      this.$emit('productSelected', product);
    },

  }
};
</script>

<style>
</style>
